import type { CreateTaskBody, Task } from 'api/models';
import { pick } from 'lodash-es';
import type { TaskType } from 'modules/Tasks/api/use-load-task-types';

export const getInitialValues = (task?: Task): Partial<CreateTaskBody> => {
  if (!task) {
    return {};
  }

  const {
    attributes: { debtor, assignee, invoices, ...rest },
  } = task;

  return {
    ...pick(rest, ['title', 'description', 'task_type_id', 'due_date', 'start_offset_days']),
    ...(debtor
      ? {
          debtor_id: debtor.id,
        }
      : undefined),
    ...(assignee
      ? {
          user_id: assignee.id,
        }
      : undefined),
    ...(invoices
      ? {
          invoice_ids: task.attributes.invoices.details.map(e => e.id),
        }
      : undefined),
  };
};

export const getTaskTypeDescription = (taskTypes: TaskType[], taskTypeId: number) =>
  taskTypes.find(type => type.id === taskTypeId)?.name;
